// ── Compartilhar Orçamento (WhatsApp / E-mail + PDF) ──
let _orcCompartilharId=null;
function compartilharOrcamento(id){
  const p=DB.get('pedidos').find(x=>x.id===id);
  if(!p){toast('Orçamento não encontrado.','error');return;}
  _orcCompartilharId=id;
  const infoEl=document.getElementById('compartilhar-orc-info');
  if(infoEl){
    const valid=orcValidade(p);
    infoEl.innerHTML=`<strong>${escapeHtml(orcNumeroLabel(p))}</strong> — ${escapeHtml(p.cliente||'Sem cliente')}<br><span style="color:var(--accent);font-weight:700">${fmtMoney(p.valor||0)}</span>${valid?` <span style="color:var(--muted);font-size:11px">· Validade: ${fmtD(valid)}</span>`:''}`;
  }
  openModal('modal-compartilhar-orc');
}
function _buildMsgOrcamento(p){
  const nome=String(p.cliente||'').split(' ')[0]||'';
  const numOrc=orcNumeroLabel(p);
  const valor=fmtMoney(p.valor||0);
  const cfgEmp=CACHE.config||{};
  const empresa=cfgEmp.nome||'nossa marmoraria';
  const itens=(p.itens||[]);
  const resumoItens=itens.slice(0,3).map(i=>i.ambiente?`  • ${i.ambiente}${i.material?' — '+i.material:''}`:null).filter(Boolean).join('\n');
  const valid=orcValidade(p);
  const validTxt=valid?`\n🗓️ Validade: ${fmtD(valid)}`:'';
  const url=p.portalToken?`${location.origin}/portal.html?t=${p.portalToken}`:'';
  const portalTxt=url?`\n\n🔗 Acompanhe sua proposta:\n${url}`:'';
  return `Olá${nome?', '+nome:''}! 👋\n\nSegue a proposta ${numOrc} de ${empresa}:\n\n💰 Valor total: ${valor}${resumoItens?'\n\nItens:\n'+resumoItens:''}${validTxt}${portalTxt}\n\nQualquer dúvida, estou à disposição!`;
}
function _compartilharOrcCanal(canal){
  const id=_orcCompartilharId;
  const p=id?DB.get('pedidos').find(x=>x.id===id):null;
  if(!p){closeModal('modal-compartilhar-orc');toast('Orçamento não encontrado.','error');return;}
  // Gerar PDF primeiro (abre janela de impressão)
  gerarPropostaOrcamento(p);
  const msg=_buildMsgOrcamento(p);
  setTimeout(()=>{
    if(canal==='whatsapp'){
      if(!p.tel){toast('Salve como PDF na janela aberta. Sem telefone cadastrado para abrir WhatsApp.','warn');return;}
      const numero=whatsappNumber(p.tel);
      window.open(`https://wa.me/${numero}?text=${encodeURIComponent(msg)}`,'_blank','noopener');
    } else {
      const email=p.email||(DB.get('clientes').find(c=>c.id===p.clienteId)?.email)||'';
      const cfgEmp=CACHE.config||{};
      const assunto=`Proposta ${orcNumeroLabel(p)} — ${cfgEmp.nome||'Marmoraria'}`;
      window.open(`mailto:${encodeURIComponent(email)}?subject=${encodeURIComponent(assunto)}&body=${encodeURIComponent(msg)}`,'_blank','noopener');
    }
    toast('PDF gerado. Salve e anexe ao envio se necessário.');
  },900);
  closeModal('modal-compartilhar-orc');
}
function enviarOrcamentoWhatsApp(id){compartilharOrcamento(id);}// alias legado
async function enfileirarNotificacaoPedido(p){
  if(!p)return;
  await publicarPortalPedido(p).catch(()=>{});
  await appCollection('notificacoes').add({organizationId:window.MarmoriaSaaS?.state.organizationId||null,pedidoId:p.id,cliente:p.cliente||'',telefone:p.tel||'',status:p.status,mensagem:`Pedido #${p.num||''}: ${SL[p.status]||p.status}`,canal:'whatsapp',situacao:'pendente',createdAt:firebase.firestore.FieldValue.serverTimestamp()}).catch(e=>console.warn('Fila de notificação',e));
}

